import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GenericComponent } from '../generic/generic.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { Store } from '@ngxs/store';

@UntilDestroy()
@Component({
    selector: 'app-lv-networks',
    templateUrl: './lv-networks.component.html',
    styleUrls: ['./lv-networks.component.scss'],
})
export class LvNetworksComponent extends GenericComponent {
    constructor(
        private readonly store: Store,
        private readonly route: ActivatedRoute,
        private readonly sidenavService: SidenavService,
    ) {
        super(route, sidenavService, store);
    }
}
